import { FormattedMessage } from 'react-intl';
import { commonMessages } from '../../../components/atoms/CommonMessages/messages';
import { useCredentialsDetailedErrorDisplayMessage } from '../../../components/CredentialsErrorBoundary/getDetailedErrorOverride/useCredentialsDetailedErrorDisplayMessage';
import {
  VerboseErrorScreen,
  VerboseErrorScreenProps,
} from '../../../components/screens/VerboseErrorScreen/VerboseErrorScreen';
import { VerboseError } from '../../../stores/app-state-errors';
import { PageView } from '../../../models/analytics';

type DetailedErrorScreenProps = {
  primaryAction: VerboseErrorScreenProps['primaryAction'];
  verboseError: VerboseError;
  viewEvent?: PageView;
};

export const DetailedErrorScreen = ({
  primaryAction,
  verboseError,
  viewEvent,
}: DetailedErrorScreenProps) => {
  const { providerName, errorReason } = verboseError;
  const { title, body } = useCredentialsDetailedErrorDisplayMessage({
    providerName,
    errorReason,
  });

  const errorScreenTitle = title || verboseError.localizedMessage;

  return (
    <VerboseErrorScreen
      viewEvent={viewEvent}
      error={verboseError}
      title={errorScreenTitle}
      body={body}
      primaryAction={primaryAction}
      primaryButtonText={<FormattedMessage {...commonMessages.ok} />}
    />
  );
};
